import { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import {
    DebDatePickerInput,
    DebFormSelect,
    DebFormTextInput,
} from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "notistack";
import { format, isValid } from "date-fns";
import { serverTask } from "../../services/mobile-server-tasks";
import { serverTasksValidationSchema } from "../../schemas/mobile-server-tasks";


const newServerTask = {
    id: "",
    state: "",
    name: "",
    lastExec: "",
    nextExec: "",
    intervalMinutes: "",
    forEveryone: false,
    exclStart: "",
    exclEnd: "",
    lastError: "",
    errorCount: 0,
    extraData: "",
    execOnlyOnce: false,
    visible: false,
    companyId: "",
    branchId: "",
    system: ""
};

const MobileServerTasks = () => {
    // MODAL DE EDICIÓN 
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] =
        useState(newServerTask);

    const [serverTasks, setserverTasks] = useState([]);
    const getServerTasks = async () => {
        setserverTasks(await serverTask.getAll());
    };

    useEffect(() => {
        getServerTasks();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values) => {
        try {
            const res = await serverTask.update(values);
            enqueueSnackbar("Server Task editada", {
                preventDuplicate: true,
                variant: "success",
            });
            closeModal();
            getServerTasks();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error al editar Sever Task", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newServerTask);
    };

    const handleEdit = (serverTask) => {
        setModalInitialValues(serverTask);
        openModal();
    };

    return (
        <Box>
            <Header title="SERVER TASKS" />
            <DataTable
                loading={!serverTasks.length}
                rows={serverTasks}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.1 },
                    { field: "name", headerName: "Nombre", flex: 1 },
                    { field: "state", headerName: "Estado", flex: 0.5 },                    
                    {
                        field: "lastExec",
                        headerName: "Última ejecución",
                        renderCell: (params) => {
                            const date  = new Date(params?.value ?? "");
                            if(isValid(date)) {
                                return format(date, "dd/MM/yyyy");
                            } else {
                                return "";
                            }
                        },
                        flex: 1,
                    },
                    {
                        field: "errorCount",
                        headerName: "Cuenta de Fallos",
                        flex: 0.5
                    },
                    {
                        field: "companyId",
                        headerName: "ID de Compañía",
                        flex: 0.5
                    },
                    {
                        field: "branchId",
                        headerName: "ID de Sucursal",
                        flex: 0.5
                    },
                    {
                        field: "system",
                        headerName: "Sistema",
                        flex: 1
                    },
                ]}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                ]}
            />

            {/* MODAL DE EDICIÓN DE SERVER TASK */}
            <DebFormModal
                maxWidth="md"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: serverTasksValidationSchema,
                }}
                headerText={
                     "Editar Server Task"
                }>
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <DebFormTextInput label={"Id"} name={"id"} disabled />
                        </Grid>
                        <Grid item xs={4}>
                            <DebFormSelect
                                            label={"Estado"}
                                            name={"state"}
                                        selectOptions={[
                                            { label: "IDLE", value: "IDLE" },
                                            { label: "EXECUTING", value: "EXECUTING" },
                                            { label: "STOPPED", value: "STOPPED" },
                                        ]}
                                        />
                        </Grid>
                        <Grid item xs={6}>
                            <DebFormTextInput label={"Nombre"} name={"name"} disabled />
                        </Grid>
                        <Grid item xs={6}>
                            <DebFormTextInput label={"Última ejecución"} name={"lastExec"} disabled />
                        </Grid>
                        <Grid item xs={6}>
                            <DebDatePickerInput
                                            label={"Próxima ejecución"}
                                            name={"nextExec"}
                                            slotProps={{
                                                textField: {
                                                error: false,
                                                },
                                            }}
                                        />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormTextInput label={"Intervalo en Minutos"} name={"intervalMinutes"} disabled />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormSelect
                                label={"Para todos"}
                                name={"forEveryone"}
                            selectOptions={[
                                { label: "Falso", value: "false" },
                                { label: "Verdadero", value: "true" },
                            ]}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormTextInput label={"Comienzo de tiempo de exclusión"} name={"exclStart"} disabled />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormTextInput label={"Final de tiempo de exclusión"} name={"exclEnd"} disabled />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormTextInput label={"Último error"} name={"lastError"} disabled />
                        </Grid>
                        <Grid item xs={3}>
                            <DebFormTextInput label={"Cuenta de fallos"} name={"errorCount"} />
                        </Grid>
                        <Grid item xs={6}>
                            <DebFormTextInput label={"Datos extra"} name={"extraData"} disabled />
                        </Grid>
                        <Grid item xs={6}>
                            
                        </Grid>
                        <Grid item xs={3}>
                                <DebFormSelect
                                label={"Ejecutar solo una vez"}
                                name={"execOnlyOnce"}
                            selectOptions={[
                                { label: "Falso", value: "false" },
                                { label: "Verdadero", value: "true" },
                            ]}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={3}>
                                <DebFormSelect
                                label={"Visible"}
                                name={"visible"}
                            selectOptions={[
                                { label: "Falso", value: "false" },
                                { label: "Verdadero", value: "true" },
                            ]}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={6}>
                                <DebFormSelect
                                label={"Sistema"}
                                name={"system"}
                            selectOptions={[
                                { label: "DEBQAPPOINTMENTS", value: "DEBQAPPOINTMENTS" },
                            ]}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={2}>
                            
                        </Grid>
                        <Grid item xs={2}>
                            <DebFormTextInput label={"ID de Compañía"} name={"companyId"} disabled />
                        </Grid>
                        <Grid item xs={2}>
                            <DebFormTextInput label={"ID de Sucursal"} name={"branchId"} disabled />
                        </Grid>
                        </Grid>        
                             
            </DebFormModal>
                    
        </Box>
    );
};

export default MobileServerTasks;
